function FullScreenPage({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative isolate flex min-h-svh w-full bg-white max-lg:flex-col lg:bg-zinc-100 dark:bg-zinc-900 dark:lg:bg-zinc-950">
      <main className="flex flex-1 flex-col lg:min-w-0">{children}</main>
    </div>
  );
}

export default FullScreenPage;
